import { createSlice } from '@reduxjs/toolkit';

export const expenseSlice = createSlice({
  name: 'expense',
  initialState: {
    loading: false,
    error: null,
    grids: [
      {
        id: 'advance',
        metaData: {
          filters: [],
          sorting: {},
          pagination: {
            page: 1,
            current: 1,
            pageSize: 10,
            total: 0,
            defaultCurrent: 1,
            showSizeChanger: true,
            pageSizeOptions: [10, 50, 100],
          },
          visibleColumns: [],
          exportColumns: [],
        },
      },
      {
        id: 'leaves',
        metaData: {
          filters: [],
          sorting: {},
          pagination: {
            page: 1,
            current: 1,
            pageSize: 5,
            total: 0,
            defaultCurrent: 1,
            showSizeChanger: true,
            pageSizeOptions: [5, 10, 50, 100],
          },
          visibleColumns: [],
          exportColumns: [],
        },
      },
      {
        id: 'allowances',
        metaData: {
          filters: [],
          sorting: {},
          pagination: {
            page: 1,
            current: 1,
            pageSize: 10,
            total: 0,
            defaultCurrent: 1,
            showSizeChanger: true,
            pageSizeOptions: [10, 50, 100],
          },
          visibleColumns: [],
          exportColumns: [],
        },
      },
      {
        id: 'deductions',
        metaData: {
          filters: [],
          sorting: {},
          pagination: {
            page: 1,
            current: 1,
            pageSize: 10,
            total: 0,
            defaultCurrent: 1,
            showSizeChanger: true,
            pageSizeOptions: [10, 50, 100],
          },
          visibleColumns: [],
          exportColumns: [],
        },
      },
      {
        id: 'incentive-imports',
        metaData: {
          filters: [],
          sorting: {},
          pagination: {
            page: 1,
            current: 1,
            pageSize: 10,
            total: 0,
            defaultCurrent: 1,
            showSizeChanger: true,
            pageSizeOptions: [10, 50, 100],
          },
          visibleColumns: [],
          exportColumns: [],
        },
      },
      {
        id: 'incentives',
        metaData: {
          filters: [],
          sorting: {},
          pagination: {
            page: 1,
            current: 1,
            pageSize: 10,
            total: 0,
            defaultCurrent: 1,
            showSizeChanger: true,
            pageSizeOptions: [10, 50, 100],
          },
          visibleColumns: [],
          exportColumns: [],
        },
      },
      {
        id: 'conveyances',
        metaData: {
          filters: [],
          sorting: {},
          pagination: {
            page: 1,
            current: 1,
            pageSize: 10,
            total: 0,
            defaultCurrent: 1,
            showSizeChanger: true,
            pageSizeOptions: [10, 50, 100],
          },
          visibleColumns: [],
          exportColumns: [],
        },
      },
    ],
    gridTabs: [],
    activeTabIndex: null,
  },
  reducers: {
    updateTableMetaData: (state, { payload }) => {
      state.metaData = payload.metaData;
    },
    updateGridMetaData: (state, { payload: { metaData, gridId } }) => {
      const gridIndex = state.grids.findIndex((grid) => grid.id === gridId);
      state.grids[gridIndex].metaData = {
        ...state.grids[gridIndex].metaData,
        ...metaData,
      };
    },
    resetFilters: (state) => {
      state.metaData = {
        ...state.metaData,
        filters: [],
      };
    },
    resetGridFilters: (state, { payload: { gridId } }) => {
      const gridIndex = state.grids.findIndex((grid) => grid.id === gridId);
      state.grids[gridIndex].metaData.filters = [];
    },
    updateVisibleColumns: (state, { payload: { gridId, visibleColumns } }) => {
      const gridIndex = state.grids.findIndex((grid) => grid.id === gridId);
      state.grids[gridIndex].metaData.visibleColumns = visibleColumns;
      state.grids[gridIndex].metaData.exportColumns = visibleColumns;
    },
    updateExportColumns: (state, { payload: { gridId, exportColumns } }) => {
      const gridIndex = state.grids.findIndex((grid) => grid.id === gridId);
      state.grids[gridIndex].metaData.exportColumns = exportColumns;
    },
  },  
});

export const {
  updateTableMetaData,
  updateGridMetaData,
  resetFilters,
  resetGridFilters,
  updateVisibleColumns,
  updateExportColumns,
} = expenseSlice.actions;

export default expenseSlice.reducer;
